module.exports = {
  fetch: `query getPrompts($promptType: String) {
    prompts(filter: { type: { eq: $promptType }}) {
      id
      name {
        en
        es
      }
      description {
        en
        es
      }
      value {
        markup{
          en
          es
        }
        content {
          en
          es
        }
      }
      type
      createdAt
      updatedAt
    }
  }`,
  add: `mutation addPrompt($value: PromptInput) {
    upsertPrompt(prompt: $value) {
      id
    }
  }`,
  save: `mutation addPrompt($value: PromptInput) {
    upsertPrompt(prompt: $value) {
      id
    }
  }`,
  remove: `
    mutation removePrompts($ids: [ID]) {
      bulkRemovePrompts(ids: $ids)
  }`
};
